import { convertArrayToObject, replaceArrayElement } from '@/helpers/utils'
import Vue from 'vue'
const requests = {}

export default {
  getAdmTerritories({ dispatch, commit, getters }, params) {},
  getZoneGroupInfo({ dispatch, commit, getters }, id) {
    return Vue.http
      .get(getters.endpoint.zonegroup(id), {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(',')
        }
      })
      .then((r) => {
        commit('setZoneGroupInfo', r.body)
      })
  },
  getZoneInfo({ dispatch, commit, getters }, id) {
    return Vue.http
      .get(getters.endpoint.zone(id), {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(',')
        }
      })
      .then((r) => {
        commit('setZoneGroupZoneInfo', r.body)
      })
  },
  addZoneGroup({ dispatch, commit, getters }, params) {
    return Vue.http
      .post(getters.endpoint.zonegroups, params, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.selectedIntervals.join(',')
        }
      })
      .then((r) => {
        const zonegroup = r.body
        commit('setZoneGroupInfo', zonegroup)

        commit('setZoneGroupToEdit', {
          ...getters.zoneGroupToEdit,
          force: false,
          id: zonegroup.id
        })

        return dispatch('getAllLayers', { layersToUpdate: ['zonegroup'] })
      })
  },

  addZone({ dispatch, commit, getters }, params) {
    return Vue.http
      .post(
        getters.endpoint.zones,
        {
          ...params
        },
        {
          params: {
            workspace: getters.workspace,
            version: getters.version,
            [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.selectedIntervals.join(',')
          }
        }
      )
      .then((r) => {
        const zone = r.body
        commit('setZoneGroupInfo', zone)
        commit('setZoneGroupToEdit', {
          ...getters.zoneGroupToEdit,
          parent: zone.group,
          force: false,
          id: zone.id
        })

        return dispatch('getAllLayers', { layersToUpdate: ['zonegroup'] }).then(() => {
          return r.body
        })
      })
  },

  copyZone({ dispatch, commit, getters }, params) {
    return Vue.http
      .post(
        getters.endpoint.copyZone(params.zoneId),
        {},
        {
          params: {
            workspace: getters.workspace,
            version: getters.version,
            [getters.objectsPeriod.scaleType.id]: params.periods
          }
        }
      )
      .then((r) => {
        return r
      })
  },
  updateZoneGroupName({ dispatch, commit, getters }, params) {
    return Vue.http
      .patch(
        getters.endpoint.zonegroup(params.id),
        {
          name: params.name
        },
        {
          params: {
            workspace: getters.workspace,
            version: getters.version,
            [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.selectedIntervals.join(',')
          }
        }
      )
      .then((r) => {
        return dispatch('getAllLayers', { layersToUpdate: ['zonegroup'] })
      })
  },

  updateZoneGroup({ dispatch, commit, getters }, params) {
    return Vue.http
      .patch(getters.endpoint.zonegroup(params.id), params, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.selectedIntervals.join(',')
        },
        before(request) {
          dispatch('abortZoneRequest', { request, key: 'zonegroup-' + params.id })
        }
      })
      .then((r) => {
        const zonegroup = r.body
        requests['zonegroup-' + params.id] = null
        return dispatch('getAllLayers', { layersToUpdate: ['zonegroup'] })
      })
      .catch((e) => {
        if (e.status === 0) {
          return 'cancel'
        }
        throw e
      })
  },

  updateZone({ dispatch, commit, getters }, params) {
    return Vue.http
      .patch(
        getters.endpoint.zone(params.id),
        {
          ...params
        },
        {
          params: {
            workspace: getters.workspace,
            version: getters.version,
            [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.selectedIntervals.join(',')
          },
          before(request) {
            dispatch('abortZoneRequest', { request, key: 'zone-' + params.id })
          }
        }
      )
      .then((r) => {
        requests['zone-' + params.id] = null
        return dispatch('getAllLayers', { layersToUpdate: ['zonegroup'] }).then(() => {
          return r.body
        })
      })
      .catch((e) => {
        if (e.status === 0) {
          return 'cancel'
        }
        throw e
      })
  },

  updateZoneName({ dispatch, commit, getters }, { id, name, groupId }) {
    return Vue.http
      .patch(
        getters.endpoint.zone(id),
        {
          id,
          name: name,
          group: groupId
        },
        {
          params: {
            workspace: getters.workspace,
            version: getters.version,
            [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.selectedIntervals.join(',')
          }
        }
      )
      .then((r) => {
        return dispatch('getAllLayers', { layersToUpdate: ['zonegroup'] })
      })
  },

  deleteZoneGroup({ dispatch, commit, getters }, id) {
    return Vue.http
      .delete(getters.endpoint.zonegroup(id), {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.selectedIntervals.join(',')
        },
        before(request) {
          dispatch('abortZoneRequest', { request, key: 'zonegroup-' + id })
        }
      })
      .then((r) => {
        const layerId = `zonegroup-${id}`
        requests[layerId] = null
        if (
          getters.zoneGroupToEdit &&
          ((getters.zoneGroupToEdit.id === id && getters.zoneGroupToEdit.type === 'zonegroup') ||
            (getters.zoneGroupToEdit.type === 'zone' && getters.zoneGroupToEdit.parent === id))
        ) {
          commit('setZoneGroupToEdit', null)
          commit('setZoneGroupInfo', null)
        }

        dispatch('removeLayerAndChildren', layerId)
      })
      .catch((e) => {
        if (e.status === 0) {
          return 'cancel'
        }
        throw e
      })
  },
  deleteZone({ dispatch, commit, getters }, params) {
    return Vue.http
      .delete(getters.endpoint.zone(params.id), {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.selectedIntervals.join(',')
        },
        before(request) {
          dispatch('abortZoneRequest', { request, key: 'zone-' + params.id })
        }
      })
      .then((r) => {
        if (getters.zoneGroupToEdit && getters.zoneGroupToEdit.id === params.id && getters.zoneGroupToEdit.type === 'zone') {
          commit('setZoneGroupToEdit', null)
          commit('setZoneGroupInfo', null)
        } else if (getters.zoneGroupToEdit && getters.zoneGroupToEdit.id === params.group && getters.zoneGroupToEdit.type === 'zonegroup') {
          commit('setZoneGroupInfo', {
            ...getters.zoneGroupInfo,
            zones: getters.zoneGroupInfo.zones.filter((v) => v.id !== params.id)
          })
        }

        requests[`zone-${params.id}`] = null
        getters.admLevels.forEach((item) => {
          dispatch('removeLayerAndChildren', `zonegroup-${params.group}-${item.adm_level}-${params.id}`)
        })
      })
      .catch((e) => {
        if (e.status === 0) {
          return 'cancel'
        }
        throw e
      })
  },

  updateZoneGroupPeriod({ dispatch, commit, getters }, params) {
    if (getters.zoneGroupPeriods && getters.zoneGroupPeriods.borders[0] !== params.borders[0]) {
      //При изменении периода сбросим данные карты,
      //Так как в другом периоде могут быть другие данные для карты
      dispatch('clearLayerMapData')
      //Сброс данных слоев для левой панели
      dispatch('clearLayerLeftPanelData')
    }
    commit('setZoneGroupPeriod', params)
  },
  abortZoneRequest({}, params) {
    if (requests[params.key]) {
      requests[params.key].abort()
    }
    requests[params.key] = params.request
  }
}



// WEBPACK FOOTER //
// ./src/store/zonegroups/actions.js